goog.provide("shadow.js.shim.module$src$svg$editor$objects$text_svg$default");
shadow.js.shim.module$src$svg$editor$objects$text_svg$default = shadow.js.shim.module$src$svg$editor$objects$text_svg.default;
